import Select from 'react-select'
import React, { useState } from 'react'
import { Drawer, Dropdown } from 'antd'
import Creatable from 'react-select/creatable'

import Confirm from '../reusable/confirm'

const ReportParams = ({ toggle, visible, params, index, onSave }) => {
    const [name, setName] = useState(params?.name)
    const [type, setType] = useState(params?.type)
    const [labelProperty, setLabel] = useState(params?.labelProperty)
    const [valueProperty, setVal] = useState(params?.valueProperty)
    const [source, setSource] = useState(params?.source)
    const [payload, setPayload] = useState(params?.payload)
    const [endpoint, setEndpoint] = useState(params?.endpoint)
    const [options, setOptions] = useState(params?.options ?? [])

    const close = () => {
        toggle()
    }

    const types = ['Text', 'Date', 'Date Range', 'Select', 'Multi Select']
    const sources = ['List', 'Query', 'SearchableQuery']

    const save = () => Confirm({
        title: 'Save changes?',
        message: 'Are you sure you want to save these changes?',
        okText: 'Save',
        onOk: () => {
            onSave({
                params: {
                    name,
                    type,
                    source,
                    endpoint,
                    labelProperty,
                    valueProperty,
                    options,
                    payload
                },
                i: index
            })
            close()
        }
    })

    const clearVals = () => {
        setOptions([])
        setEndpoint()
        setPayload()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ save } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">Add Parameters</p>
            <div>
                <div className="flex flex-wrap mt-3 -mx-3">
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Parameter Name
                        </label>
                        <input 
                            onChange={ e => setName(e.target.value) }
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                            id="grid-role-name" 
                            type="text" 
                            value={ name }
                            name="name"
                            placeholder="Daily Visits" />
                    </div>
                </div>
                <div className="flex flex-wrap mt-3 -mx-3">                  
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Type
                        </label>
                        <Select
                            isClearable
                            value={ type }
                            onChange={ val => {
                                setType(val)
                                clearVals()
                             } }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ types?.map(typ => ({ label: typ, value: typ }))  }
                            placeholder="Select Type" />
                    </div>
                </div>
                {
                    (type?.value === 'Select' || type?.value === 'Multi Select') &&
                    <div className="flex flex-wrap mt-3 -mx-3">                  
                        <div className="w-full px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Options Source
                            </label>
                            <Select
                                isClearable
                                value={ source }
                                onChange={ val => {
                                    setSource(val)
                                    clearVals()
                                 } }
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ sources?.map(src => ({ label: src, value: src }))  }
                                placeholder="Select Source" />
                        </div>
                    </div>
                }
                {
                    source ?
                        source?.value === 'List' ?
                            <div className="flex flex-wrap mt-2 -mx-3">                  
                                <div className="w-full px-3 mb-0">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                        Options
                                    </label>
                                    <Creatable
                                        isMulti
                                        value={ options }
                                        options={ options }
                                        onChange={ setOptions }
                                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                        onCreateOption={ val => setOptions(prev => [...prev, { label: val, value: val }]) }
                                        placeholder="Add Options" />
                                </div>
                            </div>
                        :
                            <>
                                <div className="flex flex-wrap mt-3 -mx-3">
                                    <div className="w-full px-3 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                            Endpoint
                                        </label>
                                        <input 
                                            onChange={ e => setEndpoint(e.target.value) }
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                            id="grid-endpoint" 
                                            type="text" 
                                            value={ endpoint }
                                            name="endpoint"
                                            placeholder="patients" />
                                    </div>
                                </div>
                                <div className="flex flex-wrap mt-3 -mx-3">
                                    <div className="w-full px-3 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                            Label Property
                                        </label>
                                        <input 
                                            onChange={ e => setLabel(e.target.value) }
                                            className="appearance-none block my-0 w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                            id="grid-label" 
                                            type="text" 
                                            value={ labelProperty }
                                            name="label"
                                            placeholder="name" />
                                        <p className="text-gray-500 my-0 text-xs italic">Leave this field blank if the object received is an array of text values</p>
                                    </div>
                                </div>
                                <div className="flex flex-wrap mt-3 -mx-3">
                                    <div className="w-full px-3 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                            Value Property
                                        </label>
                                        <input 
                                            onChange={ e => setVal(e.target.value) }
                                            className="appearance-none block my-0 w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                            id="grid-val" 
                                            type="text" 
                                            value={ valueProperty }
                                            name="val"
                                            placeholder="id" />
                                        <p className="text-gray-500 my-0 text-xs italic">Leave this field blank if the object received is an array of text values</p>
                                    </div>
                                </div>
                                <div className="flex flex-wrap mt-3 -mx-3">                  
                                    <div className="w-full px-3 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                            Payload
                                        </label>
                                        <textarea 
                                            rows="4"
                                            onChange={ e => setPayload(e.target.value) }
                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                            id="grid-payload" 
                                            type="text" 
                                            value={ payload }
                                            name="payload"
                                            placeholder="{ limit: 1000 }" />
                                    </div>
                                </div>
                            </>
                    : null
                }
            </div>
        </Drawer>
    )
}

export default ReportParams